import buildDocumentRequest from './buildDocumentRequest';
import requestDocuments from './requestDocuments';

export * from './types/api';

export {
  buildDocumentRequest,
  requestDocuments,
};
